module.exports = __webpack_public_path__ + "img/xk.a3817dbd.png";